<template>
    <div v-if="textLinks.length > 0" class="mb-5 space-y-0.5">
        <Link
            v-for="link in textLinks"
            :key="link.url"
            :href="link.url"
            :class="urlIsActive(link.url, page.url) ? 'font-bold text-primary' : 'text-zinc-800 hover:text-primary'"
            class="flex w-full items-center rounded px-1 py-1.5 text-sm transition"
            v-safe-html="link.label"
        />
    </div>
</template>

<script setup lang="ts">
import { textCategoryLinks } from '@/lib/category/categoryLinks';
import { urlIsActive } from '@/lib/urls';
import type { CategoryLinkObject } from '@/types/generated';
import { Link, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps<{
    links: CategoryLinkObject[];
}>();

const page = usePage();

const textLinks = computed((): CategoryLinkObject[] => textCategoryLinks(props.links));
</script>
